<template>
  <div class="page-wrapper storybook-cnc-switch">
    <StorybookTemplate title="CncSwitch" pathComponent="/shared/elements/global/v1/CncSwitch.vue" :propList="propList" :form.sync="form">
      <CncSwitch v-bind="form">{{ form.name }}</CncSwitch>
    </StorybookTemplate>
  </div>
</template>

<script>
export default {
  components: {
    StorybookTemplate: () => import('../../../../components/StorybookTemplate.vue')
  },
  data () {
    return {
      propList: [
        { name: 'value', type: 'boolean', required: true },
        { name: 'className', type: 'input', param: 'className', default: '' },
        { name: 'disabled', type: 'boolean', required: false },
        { name: 'activeText', type: 'input', param: 'activeText', default: 'yes' },
        { name: 'activeColor', type: 'input', param: 'activeColor', default: '' },
        { name: 'inactiveText', type: 'input', param: 'inactiveText', default: 'no' },
        { name: 'inactiveColor', type: 'input', param: 'inactiveColor', default: '' }
      ],

      form: {
        value: false,
        className: '',
        disabled: false,
        activeText: 'yes',
        activeColor: '',
        inactiveText: 'no',
        inactiveColor: ''
      }
    }
  }
}
</script>
